import {connect} from "react-redux"

import State from "../../../models/State"
import {setSelectedFilterThunk} from "../../../ducks/tabbedFilters"
import getLocaleFromHeaders from "../../../utils/getLocaleFromHeaders"
import getRealmFromHeaders from "../../../utils/getRealmFromHeaders"
import {getSelectedFacetFilters} from "../../../utils/getSelectedFacetFilters"
import {isFacetFiltersSelected} from "../../../utils/isFacetFiltersSelected"
import TrackFilterExpanded from "../../../events/trackEvent/events/trackFilterExpanded"

type OwnProps = {
    facetName: string
    facetDisplayName: string
    isFirstFacet: boolean
}

type StateProps = {
    isFocused: boolean
    hasSelectedFilters: boolean
    hideTopBorder: boolean
    hasSelectedFacet: boolean
    disabled: boolean
    selectedFacetFilters: string
}
const mapStateToProps = (state: State, ownProps: OwnProps) => {
    const {facetName, isFirstFacet} = ownProps
    const {filters, selectedFilter, historicFacetFilter, facets, isOpen} = state.tabbedFilters
    const {disabled} = filters[facetName]
    const filter = filters[facetName]
    const hasSelectedFacet = Boolean(selectedFilter)
    const hasSelectedFilters = isFacetFiltersSelected(filter, historicFacetFilter)
    let selectedFacetFilters: undefined | string

    if (!hasSelectedFacet && isOpen) {
        selectedFacetFilters = getSelectedFacetFilters({
            historicFacetFilter,
            filter,
            facets,
            locale: getLocaleFromHeaders(state.request.headers),
            realm: getRealmFromHeaders(state.request.headers),
            globalPriceFormattingConfig: state.search.globalPriceFormattingConfig,
        })
    }

    return {
        isFocused: hasSelectedFacet ? facetName === selectedFilter : undefined,
        hasSelectedFilters,
        hideTopBorder: isFirstFacet && hasSelectedFacet,
        hasSelectedFacet,
        disabled,
        selectedFacetFilters,
    } as StateProps
}

export const mapDispatchToProps = (dispatch: any) => ({
    setSelectedFacet: ({facetName, facetDisplayName}: {facetName: string; facetDisplayName: string}) => {
        TrackFilterExpanded(facetDisplayName)
        dispatch(setSelectedFilterThunk(facetName))
    },
})

export default connect(mapStateToProps, mapDispatchToProps)
